'use strict';

const Item = require('../Item');

/**
 * @class
 * @hideconstructor
 * @extends HomeyAPIV3.Item
 * @memberof HomeyAPIV3.ManagerInsights
 */
class Log extends Item {

  async getEntries() {
    return this.manager.getLogEntries({
      id: this.id,
    });
  }

  static transformGet(item) {
    item = super.transformGet(item);

    delete item.ownerName; // Prepare for back-end change

    return item;
  }

  get uri() {
    console.warn('Log.uri is deprecated. Use Log.ownerUri instead.');
    return undefined;
  }

  get uriObj() {
    console.warn('Log.uriObj is deprecated.');
    return undefined;
  }

  get ownerName() {
    console.warn('Log.ownerName is deprecated.');
    return undefined;
  }

}

module.exports = Log;
